import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Headroom from "react-headroom";
import classNames from "classnames/bind";
import loadable from "@loadable/component";
import styles from "./index.css";
import SmallScreenSort from "../Sort/SmallScreenSort";
import getPinStart from "./getPinStart";
import { showFilterOverlay } from "../../state/modules/layout/actions";
import { hasSelectedFacets } from "../../state/modules/facets";
import { withTranslation } from "../translation/";
import ClientOnly from "../ClientOnly";

const FilterLayoutContainer = loadable(
  () => import(/* webpackChunkName: "FILTER_SORT_OVERLAY" */ "../FilterLayout"),
  { fallback: null },
);

const RefinementListContainer = loadable(
  () =>
    import(/* webpackChunkName: "FILTER_SORT_OVERLAY" */ "../RefinementsList"),
  { fallback: null },
);

const SortLayoutContainer = loadable(
  () => import(/* webpackChunkName: "FILTER_SORT_OVERLAY" */ "../SortLayout"),
  { fallback: null },
);

const SortListContainer = loadable(
  () =>
    import(/* webpackChunkName: "FILTER_SORT_OVERLAY" */ "../Sort/SortList"),
  { fallback: null },
);

const combineClasses = classNames.bind(styles);

export const SmallScreenHeader = ({ formatTranslation }) => {
  const dispatch = useDispatch();
  const hasSelectedFacetsValue = useSelector(hasSelectedFacets);

  return (
    <div className={styles.container}>
      <Headroom
        className={styles.stickyHeader}
        disableInlineStyles={true}
        pinStart={getPinStart}
        upTolerance={17}
      >
        <div className={styles.sortControls}>
          <SmallScreenSort />
        </div>
        <div className={styles.filterControls}>
          <button
            className={combineClasses({
              filterButton: true,
              filterButton_checked: hasSelectedFacetsValue,
            })}
            onClick={() => dispatch(showFilterOverlay())}
          >
            {formatTranslation("plp_web_search_filter_label")}
          </button>
        </div>
      </Headroom>
      <ClientOnly>
        <FilterLayoutContainer>
          <RefinementListContainer />
        </FilterLayoutContainer>
        <SortLayoutContainer>
          <SortListContainer />
        </SortLayoutContainer>
      </ClientOnly>
    </div>
  );
};

SmallScreenHeader.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(SmallScreenHeader);
